export const SITE = {
  name: "Eli Capital Investments",
  shortName: "Eli Capital",
  descriptor: "Wholesale Merchandise & Import/Export Sourcing",
  phoneDisplay: "954-702-3558",
  phoneHref: "tel:+19547023558",
  email: "elicapitalinvestments@gmail.com",
  emailHref: "mailto:elicapitalinvestments@gmail.com",
  address: {
    street: "16234 NW 1st Street",
    city: "Pembroke Pines",
    state: "Florida",
    zip: "33028",
  },
  addressFull: "16234 NW 1st Street, Pembroke Pines, Florida 33028",
  mainMessage:
    "Contact Eli Capital Investments for wholesale merchandise, perishables, overstock, shelf pulls, and import/export sourcing.",
  policies: [
    { label: "Privacy Policy", path: "/privacy" },
    { label: "Terms of Sale", path: "/terms-of-sale" },
    { label: "Shipping Policy", path: "/shipping" },
    { label: "Refund Policy", path: "/refund" },
  ],
};

export const HOME_TITLE = "Wholesale & Import/Export Sourcing | Eli Capital Investments";
export const HOME_DESCRIPTION =
  "Wholesale merchandise, overstock, shelf pulls, perishables & import/export sourcing for Amazon sellers, resellers and overseas buyers. Call for pricing.";
